import { Channel } from './channel';
import { MotorAlarmSetting } from './motor-alarm-setting';
import { AlarmPropertyList } from './repose-group';

export class OutputSetting {
    id?: string;
    vesselId: string;
    slotId: string;
    terminalNum: number;
    channels: OutputSettingChannel[];
    signalType?: SignalType;
    signalWidth?: number;
    outputMode?: OutputMode;
    sourceChannelCondition?: SourceChannelCondition;
}

export class OutputSettingChannel {
    id?: string;
    channelId: string;
    settingId?: string;
    channel: Channel;
    index?: number;
    triggerCondition?: TriggerCondition;
    alarmCondition?: AlarmPropertyList[];
    statusCondition?: string[];
    statusValue?: number;
}

export const DOSignalWidthDefault = 1000;

export enum SignalType {
    UNDEFINED = 'undefined',
    ALARM = 'alarm-type',
    ON_OFF = 'on-off',
    ONE_SHOT = 'one-shot',
}

export enum SourceChannelCondition {
    UNDEFINED = 'undefined',
    OR = 'or',
    AND = 'and',
}

export enum TriggerCondition {
    UNDEFINED = 'undefined',
    ALARM = 'alarm-condition',
    STATUS = 'status-condition',
}

export enum OutputMode {
    UNDEFINED = 'undefined',
    FUNCTIONAL_TEST = 'functional-test',
    LAMP_TEST = 'lamp-test',
    BOTH = 'both-tests',
    NEITHER = 'no-tests',
}

export const signalTypeMap = new Map<SignalType, string>([
    [SignalType.ALARM, 'output-settings.DO.selector.signal.alarm'],
    [SignalType.ON_OFF, 'output-settings.DO.selector.signal.on-off'],
    [SignalType.ONE_SHOT, 'output-settings.DO.selector.signal.one-shot'],
]);

export const modeTypeMap = new Map<OutputMode, string>([
    [OutputMode.FUNCTIONAL_TEST, 'output-settings.DO.selector.mode.functional'],
    [OutputMode.LAMP_TEST, 'output-settings.DO.selector.mode.lamp'],
    [OutputMode.BOTH, 'output-settings.DO.selector.mode.both'],
    [OutputMode.NEITHER, 'output-settings.DO.selector.mode.neither'],
]);

export const maxDigitalChannels = 32;

export const STATUS_KEY_BIT_VALUES: Record<string, number> = {
    runStatusString5: 128,
    runStatusString4: 16,
    runStatusString3: 8,
    runStatusString2: 4,
    runStatusString1: 2,
    stbyStatusString: 32,
    stopStatusString: 64,
};

export function getStatusStringsFromValue(value: number, motorChannelSetting: MotorAlarmSetting): string[] {
    if (!value && value !== 0) return [];
    const binary8bit = value?.toString(2).padStart(8, '0').split('');
    const result = [];

    for (const [key, bitValue] of Object.entries(STATUS_KEY_BIT_VALUES)) {
        const bitIndex = 7 - Math.log2(bitValue);
        if (binary8bit[bitIndex] == '1') {
            result.push(motorChannelSetting[key]);
        }
    }
    if (value === 0 || binary8bit[1] == '1') {
        result.push(motorChannelSetting.stopStatusString);
    }

    return result;
}
